import React, { useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import phone from "../../Assets/svg/phone grey.svg";
import mail from "../../Assets/svg/mail grey.svg";
import avatar from "../../Assets/svg/avatar-img.svg";
import down from "../../Assets/svg/down arrow new.svg";
import ModalComponent from "../modules/Modal";
import SwitchButton from "../modules/SwitchButton";
import tick from "../../Assets/svg/green-bg-tick.svg";
import reject from "../../Assets/svg/reject icon.svg";
import Input from "../modules/Input";
import GradientLoader from "../modules/Loader";
import { api } from "../../Services";
import {useDispatch, useSelector } from "react-redux";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";

function RequestListView(props) {
  const [msg, setMsg] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [reason, setReason] = useState("");
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const dispatch = useDispatch();

  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Request a Session",
    countDown: " ",
    desc: "",
  });
  const tokenData = useSelector((state) => state.tokens.tokens);

  const mentorContent = () => {
    return (
      <div className="feedback-content">
        <div className="mentor-info-section">
          <div className="mentor-info">
            <div className="image img-section">
              {/* <img src={avatar} alt="avatar" /> */}
              {props.item?.image && props.item?.imageExtension && (
                <img
                  // className="image"
                  src={
                    props.item?.image && props.item?.imageExtension
                      ? "data:image/" +
                        props.item?.imageExtension +
                        ";base64," +
                        props.item?.image
                      : null
                  }
                  alt="Preview"
                  // style={{ maxWidth: "100%", height: "100%" }}
                />
              )}
            </div>
            <div className="mentor-text">
              <span className="name">
                {props?.item?.name || props?.item?.fullName}
              </span>
              <span className="sub-option-text">{props?.item?.college}</span>
            </div>
          </div>
          <div className="sentence">
            {props?.item?.message?.split("\n").map((paragraph, index) => (
              <span className="sub-option-text" key={index}>
                {paragraph}
              </span>
            ))}
          </div>
        </div>
        {/* <div className="check-btns">
          <div className="heading">
            <span className="name">Share your details</span>{" "}
          </div>
          <div className="mentor-info-section">
            <div className="info">
              {" "}
              <div className="info-icon">
                <img src={mail} alt="phone" />
              </div>
              <span className="subTitle">{props.item?.email}</span>
            </div>
          </div>
        </div> */}

        <div className="cred-btn">
          <Button
            onClickHandler={() => checkRequest("Accepted")}
            value={"Accept and Share"}
            type={"contained"}
          />
          
        </div>
        <div className="footer-text">
        By clicking "Accept and Share," you agree to our terms & conditions allowing us to share your contact details with scholars for communication purposes.
        </div>
      </div>
    );
  };
  const declineRequest = () => {
    return (
      <div className="feedback-content">
        <div className="mentor-info-section">
          <div className="mentor-info">
            {/* <img src={avatar} alt="avatar" /> */}
            <div className="image img-section">
              {/* <img src={avatar} alt="avatar" /> */}
              {props.item?.image && props.item?.imageExtension && (
                <img
                  // className="image"
                  src={
                    props.item?.image && props.item?.imageExtension
                      ? "data:image/" +
                        props.item?.imageExtension +
                        ";base64," +
                        props.item?.image
                      : null
                  }
                  alt="Preview"
                  // style={{ maxWidth: "100%", height: "100%" }}
                />
              )}
            </div>
            <div className="mentor-text">
              <span className="name">
                {props?.item?.name || props?.item?.fullName}
              </span>
              <span className="sub-option-text">{props?.item?.expertise}</span>
            </div>
          </div>

          {/* <div className="sentence">
              {data.split("\n").map((paragraph, index) => (
                <span className="sub-option-text" key={index}>
                  {paragraph}
                </span>
              ))}
            </div> */}
        </div>
        <div
          className="set-title"
          style={{ textAlign: "left", margin: "2% 0" }}
        >
          Write your message
        </div>
        <div className="comment-field">
          <Input
            onChange={(e) => setReason(e.replace(/[^a-zA-Z0-9. ]/g, ""))}
            placeholder={"Could you tell us a little more?"}
            multiline={true}
          />
        </div>

        <div className="cred-btn">
          <Button
            onClickHandler={() =>
              // setModalData({
              //   ...ModalData,
              //   type: "complete",
              //   title: (
              //     <div className="set-title">
              //       <div className="happy-icon">
              //         <img src={reject} alt="tick" />
              //       </div>
              //       {/* Connection request sent! */}
              //       Connection request declined
              //     </div>
              //   ),
              // //   desc: "Your contact details will be shared via email",
              // })
              checkRequest("Decline")
            }
            value={"Submit"}
            type={"contained"}
          />
          {/* <Button
            onClickHandler={() =>
              setModalData({
                ...ModalData,
                type: "submit",
                title: (
                  <div className="set-title">
                    <div className="happy-icon">
                      <img src={tick} alt="tick" />
                    </div>
                    Mentorship session request sent!
                  </div>
                ),
                desc: "You’ll receive an update via email once your request is accepted.",
              })
            }
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Send"}
            type={"contained"}
          /> */}
        </div>
      </div>
    );
  };
  const showMsg = (info) => {
    if ((props?.item?.requestStatus || props?.item?.status) === "Decline") {
      return (
        <div className="sentence">
          <span className="upload-top-text">Reason for Decline</span>

          {info?.requestRejectionReason?.split("\n").map((paragraph, index) => (
            <span className="sub-option-text" key={index}>
              {paragraph}
            </span>
          ))}
        </div>
      );
    } else {
      return (
        <div className="sentence">
          {info?.message?.split("\n").map((paragraph, index) => (
            <span className="sub-option-text" key={index}>
              {paragraph}
            </span>
          ))}
        </div>
      );
    }
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const makeRequest = async (type) => {
    // let item = myMentors.filter((a) => a.id === id)[0];

    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      requestId: props.item?.requestId,
      requestStatus: type,
      requestDeclineReason: reason,
    };

    try {
      const request = await api.acceptAlumni(tokenData.token, data);
      console.log("users", request);
      if (
        request.statusCode !== 200 &&
        request.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (
        error?.data?.includes("Session expired")
      ) {
        logoutMsg();
      }
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async (type) => {
    setUploading(true);
    try {
      const request = await makeRequest(type);
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "submit",
          title:
            type === "Accepted" ? (
              <div className="set-title">
                <div className="happy-icon">
                  <img src={tick} alt="tick" />
                </div>
                Connection request sent!
                {/* Connection request declined */}
              </div>
            ) : (
              <div className="set-title">
                <div className="happy-icon">
                  <img src={reject} alt="tick" />
                </div>
                {/* Connection request sent! */}
                Connection request declined
              </div>
            ),
          desc: "",
        });
        // getMentors();
        props.getAlumni();
      }
    } catch (error) {
      console.error("Error", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };

  return (
    <div className="certificate">
      {/* <div className="image img-section">
        <img src={avatar} alt="avatar" />
      </div> */}
      <div className="image img-section">
        {/* <img src={avatar} alt="avatar" /> */}
        {props.item?.image && props.item?.imageExtension && (
          <img
            // className="image"
            src={
              props.item?.image && props.item?.imageExtension
                ? "data:image/" +
                  props.item?.imageExtension +
                  ";base64," +
                  props.item?.image
                : null
            }
            alt="Preview"
            // style={{ maxWidth: "100%", height: "100%" }}
          />
        )}
      </div>
      <div className="mentor-section">
        <div className="mentor-top">
          <div className="mentor-left">
            <span className="md-title">
              {props?.item?.name || props?.item?.fullName}
            </span>
            <span className="role">{props?.item?.expertise}</span>
            {/* <div className="skill-section">
            <div className="skill-item">PGDM, 2023-25</div>
            <div className="skill-item">Bengaluru, Karnataka</div>
          </div> */}
            <div className="btn-section">
              <Button
                onClickHandler={() => setMsg(!msg)}
                value={
                  <div className={`msg-view-btn ${msg ? "hide" : "show"}`}>
                    <img src={down} alt="down" />
                    <span>{msg ? "hide message" : "view message"}</span>
                  </div>
                }
                type={"only-text"}
              />
            </div>
            {/* {msg && (
            <div className="sentence">
              {data.split("\n").map((paragraph, index) => (
                <span className="sub-option-text" key={index}>
                  {paragraph}
                </span>
              ))}
            </div>
          )} */}
          </div>
          <div className="mentor-right">
            <div className="sub-option-text">{props?.item?.date}</div>
            <div className="right-btm">
              <Button
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    type: "request",
                    show: true,
                    title: "Connection Request Accept",
                    desc: "",
                  })
                }
                value={"Accept"}
                type={"contained"}
              />
              <Button
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    type: "cancel",
                    show: true,
                    desc: "",
                    title: "Connection Request Decline",
                  })
                }
                value={"Decline"}
                type={"only-text"}
              />
            </div>
            {/* <div className="skill-section">
      <span className="skill subTitle">Resume Building</span>
      <img src={down} alt="down" />
    </div> */}
          </div>
        </div>
        <div className="mentor-btm">
          {/* {showMsg(props?.item )} */}
          {msg &&
            (props?.item?.message || props?.item?.requestRejectionReason) &&
            showMsg(props?.item)}
          {/* {showMsg(props?.item?.message || data)} */}
        </div>
      </div>
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={"mentor-request"}
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {ModalData.type === "request"
            ? mentorContent()
            : ModalData.type === "cancel"
            ? declineRequest()
            : null}
        </ModalComponent>
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default RequestListView;
